/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React, {
    Fragment,
    useEffect,
    useState
} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {
    Button,
    ModalBody,
    ModalFooter,
    Spinner
} from "react-bootstrap";
import Modal from "./Modal";
import {
    CLOSE_TERMS,
    OPEN_TERMS
} from "../../Redux/Actions/Types/termsActionTypes";
import AuthService from "../../Services/Core/AuthService";
import {service as TermsService} from "../../Services/TermsService";
import {TOS_LAST_UPDATED} from "../../Constants";
import DateUtils from "../../Utils/DateUtils";

import {useLoginEffect} from "../../Hooks/useLoginEffect";

const TermsOfServiceModal = (props) => {
    
    const {
        url = '/templates/terms.html'
    } = props;
    
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false)
    
    const show = useSelector(state => state.termsState.termsOpen);
    const user = useSelector(state => state.userState.user);
    
    const termsAccepted = user?.termsAccepted ?? null;
    const termsNeedAcceptance = !termsAccepted || (DateUtils.ParseUTCDateTime(termsAccepted) < new Date(TOS_LAST_UPDATED));
    
    useLoginEffect(() => {
        if (termsNeedAcceptance) {
            dispatch({ type: OPEN_TERMS });
        }
    }, [termsNeedAcceptance]);

    useEffect(() => {
        if (show && !termsNeedAcceptance) {
            dispatch({ type: CLOSE_TERMS });
        }
    }, [show, termsNeedAcceptance]);

    const defaultOnAccept = async () => {
        setLoading(true);
        try {
            const result = await TermsService.Accept();
            if(result) {
                dispatch({type: CLOSE_TERMS});
            }
        } catch (error) {
            alert("An error occurred while accepting the terms of service:\n" + (error.message ?? '') + "\nYou may be asked to accept the terms again when you log in next time.");
            dispatch({ type: CLOSE_TERMS });
            throw error;
        } finally {
            setLoading(false);
        }
    }
    
    const defaultOnDecline = async () => {
        dispatch({ type: CLOSE_TERMS });
        return AuthService.Logout();
    };
    
    const {
        onAccept = defaultOnAccept,
        onDecline = defaultOnDecline,
    } = props;
    
    return (
        <Modal
            size="lg"
            show={show}
            onHide={() => dispatch({type: CLOSE_TERMS})}
            hideCloseButton
            static
        >
            <ModalBody className="p-0">
                <iframe src={url} />
            </ModalBody>
            <ModalFooter>
                {
                    termsNeedAcceptance ? <Fragment>
                        <Button disabled={loading} variant="complete" className="ml-3 btn-primary" onClick={async () => {
                            setLoading(true);
                            await onAccept();
                            setLoading(false);
                        }}>
                            Agree
                            {loading && <Spinner animation="border" size="sm" className="ml-2"/>}
                        </Button>
                        <Button disabled={loading} variant="danger" className="ml-3" onClick={async () => {
                            await onDecline?.();
                        }}>
                            Log Out
                        </Button>
                    </Fragment> : <Button disabled={loading} variant="danger" className="ml-3" onClick={() => {
                        dispatch({ type: CLOSE_TERMS });
                    }}>
                        Close
                    </Button>
                }
            </ModalFooter>
        </Modal>
    )
};

export default TermsOfServiceModal;
